import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';

var QUERY_CATEGORIZATION_EXPERIMENT = 'product_search_query_categorization';
var QUERY_CATEGORIZATION_EXPERIMENT_VARIATION = 'test';
var PRODUCT_SEARCH_ON_FOCUS_CONTENT = 'product_search_on_focus_content';
var PRODUCT_SEARCH_ON_FOCUS_CONTENT_VARIATION_CONTROL = 'control';
var PRODUCT_SEARCH_ON_FOCUS_CONTENT_VARIATION_TEST = 'test';
var PRODUCT_SEARCH_QUERY_SUGGESTIONS_EXPERIMENT = 'product_search_query_suggestions';
var PRODUCT_SEARCH_QUERY_SUGGESTIONS_CONTROL = 'control';
var PRODUCT_SEARCH_QUERY_SUGGESTIONS_VARIATION = 'test';
var ENABLED_AB_TEST_FEATURES = _defineProperty(_defineProperty(_defineProperty({}, QUERY_CATEGORIZATION_EXPERIMENT, {
  variation: QUERY_CATEGORIZATION_EXPERIMENT_VARIATION
}), PRODUCT_SEARCH_ON_FOCUS_CONTENT, {
  variation: PRODUCT_SEARCH_ON_FOCUS_CONTENT_VARIATION_TEST
}), PRODUCT_SEARCH_QUERY_SUGGESTIONS_EXPERIMENT, {
  variation: PRODUCT_SEARCH_QUERY_SUGGESTIONS_VARIATION
});

export { ENABLED_AB_TEST_FEATURES, PRODUCT_SEARCH_ON_FOCUS_CONTENT, PRODUCT_SEARCH_ON_FOCUS_CONTENT_VARIATION_CONTROL, PRODUCT_SEARCH_ON_FOCUS_CONTENT_VARIATION_TEST, PRODUCT_SEARCH_QUERY_SUGGESTIONS_CONTROL, PRODUCT_SEARCH_QUERY_SUGGESTIONS_EXPERIMENT, PRODUCT_SEARCH_QUERY_SUGGESTIONS_VARIATION, QUERY_CATEGORIZATION_EXPERIMENT, QUERY_CATEGORIZATION_EXPERIMENT_VARIATION };
//# sourceMappingURL=abTestConstants.js.map
